import getStore from '../store/store';
import { loadCalendarFoldersToStore } from '../actions/internalActions';
import { mutator } from 'satcheljs';

export default mutator(loadCalendarFoldersToStore, actionMessage => {
    const { calendarFolders } = actionMessage;
    const agendaOptionStore = getStore();

    if (calendarFolders && calendarFolders.length > 0) {
        agendaOptionStore.serverCalendarFolders = calendarFolders;
        agendaOptionStore.serverCalendarFolders.forEach(folder => {
            agendaOptionStore.agendaMailDisabledMap.set(
                folder.FolderId.Id,
                folder.AgendaMailDisabled
            );
        });
    }
});
